import { FaBars } from "react-icons/fa";
import { NavLink as Link } from "react-router-dom";
import styled from "styled-components";

export const Nav = styled.nav`
  background: rgb(225,240,255,0.8);
  backdrop-filter: blur(10px);
  position: fixed;
  top: 0;
  left: 0;
  height: 60px;
  padding-top: 10px;
  width: 100vw;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0.2rem 10vw;
  z-index: 12;

  & .hidden {
    display: block;
  }

  & #menu-button {
    display: none;
    font-size: 2rem;
    color: var(--color-b);
  }

  @media screen and (max-width: 768px) {
    background: transparent;
    backdrop-filter: none;
    height: fit-content;
    padding-left: 0;

    & .hidden {
      display: none;
    }

    & #menu-button {
      display: block;
      width: 130px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }

    & #menu-button svg {
      display: block;
      position: relative;
      margin-top: -40px;
    }
  }
`;

export const NavLink = styled(Link)`
  color: var(--color-b);
  display: block;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  padding: 0 1rem;
  height: 100%;
  cursor: pointer;
  &.active {
    color: var(--color-accent);
  }
  &:hover {
    color: var(--color-b-light);
  }

  & img {
    top: 5px;
    height: 100px;
    position: fixed;
    left: 20px;
    display: block;
  }

  @media screen and (max-width: 768px) {
    & img {
      height: 90px;
      display: block;
      position: relative;
      left: 0;
    }
  }
`;

export const Bars = styled(FaBars)`
  display: none;
  color: #808080;
  @media screen and (max-width: 768px) {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(-100%, 75%);
    font-size: 1.8rem;
    cursor: pointer;
  }
`;

export const NavMenu = styled.div`
  display: flex;
  align-items: center;
  margin-left: 50px;
  /* Second Nav */
  /* margin-right: 24px; */
  /* Third Nav */
  /* width: 100vw;
white-space: nowrap; */
  @media screen and (max-width: 768px) {
    margin-left: 0vw;
    margin-top: -5px;
    padding-bottom: 20px;

    width: fit-content;
    flex-direction: column;
    gap: 15px;
    background: rgb(225,240,255,0.95);
    backdrop-filter: blur(10px);
    border-radius: 0 0 25px 0;
  }
`;